import React from 'react'
import {Spin, Popconfirm, Timeline,  Button, Input,message, Empty, DatePicker} from 'antd';
import moment from 'moment';
import EssaModal from '@components/EssaModal/EssaModal';
import PropTypes from 'prop-types';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import {isEmpty} from "@utils/utils";
import Lang from "@components/Lang/Lang";
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import { toFixedWithCommas} from "@utils/number-util";
import ShipperManagementAction from "../../ShipperManagement.action";
import dayjs from 'dayjs';
import "./index.less"
/**
 * 清关登记
 *
 * @author FJJ
 * @version 1.0
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
const { TextArea } = Input;
export default class CustomsClearance extends React.Component {
    static defaultProps = {
        containerId:"", //container Id
    }
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading:false,
            objValue:{},//入参
            objErr:{},//错误提示
            isCustomsDeclarationRequired:false,//海关申报内容是否必填
            list:[
            ],
            currState:"",//当前状态
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    // 打开
    open(flag=false){
        if(flag){
            const { containerId} = this.props;
            // 清关记录列表
            // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7873
            ShipperManagementAction.autoFetchAction({
                containerId:containerId
            },"/service/mg/container/customs/clearance/list").then(res=>{
                this.loading(false);
                const resData = res.data;
                const { success, valid,model={},models} = resData;
                if (success &&valid) {
                    // 成功
                    this.setState({
                        isModalVisible: true,
                        list: models||[],
                        currState:model.type,
                        isCustomsDeclarationRequired:model.isCustomsDeclarationRequired
                    })
                }else if(resData.message){
                    message.warning(resData.message)
                }else {
                    message.warning(Lang({id:"BaoCunShiBai"}))
                }
            })
        }else {
            this.setState({
                isModalVisible: flag,
                objValue:{}
            })
        }
    }
    // 赋值
    changeInputValue(field,iType){
        let {objValue} = this.state;
        objValue[field] = iType;
        this.setState({
            objValue
        })
    }
    // 清关登记
    registration(){
        const {objValue,list,isCustomsDeclarationRequired} = this.state;
        let objErr = {}
        if(isEmpty(objValue.type)){
            objErr.type = Lang({id:"QingXuanZeQingGuanZhuangTai",default:"请选择清关状态"})
        }else if(objValue.type=="30"&&list.length==0){//必须有开始清关的记录才能点清关完成
            const tips = Lang({id:"KaiShiQingGuanHouCaiNengCaoZuoQingGuanWanCheng",default:"开始清关后才能操作清关完成"})
                objErr.type =tips;
        }else if(objValue.type=="30"&&isCustomsDeclarationRequired){//清关完成状态下，检查海关申报字段
            if(isEmpty(objValue.customsDeclarationCode)){
                objErr.customsDeclarationCode = Lang({id:"QingShuRuHaiGuanShenBaoBianMa",default:"请输入海关申报编码"})
            }
            if(isEmpty(objValue.customsDeclarationDate)){
                objErr.customsDeclarationDate = Lang({id:"QingXuanZeHaiGuanShenBaoRiQi",default:"请选择海关申报日期"})
            }
        }
        
        // 如果没有错误，提交表单
        if(Object.keys(objErr).length===0){
            const { containerId} = this.props;
            this.save({
                ...objValue,
                containerId:containerId
            })
        }
        
        this.setState({
            objErr:objErr
        })
    }
    /*
    * 保存 清关记录列表
    * /service/mg/container/customs/clearance/add
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7874
    * */
    save(data){
        this.loading(true);
        ShipperManagementAction.autoFetchAction(data,"/service/mg/container/customs/clearance/add").then(res=>{
            this.loading(false);
            const resData = res.data;
            const { success, valid,} = resData;
            if (success &&valid) {
                // 成功
                this.open(false)
                message.success(Lang({id:"XinZengJiLuChengGong",default:"新增记录成功"}))
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        })
    }
    renderChild(list=[]){        
        let childList = []
        list.forEach((item,inx)=>{
            childList.push({
                key: `timeline-item-${inx}`,
                children: this.stepItem(item),
                color: inx==0?'red':'gray',
            })
        })
        return childList
    }
    stepItem(item={},index) {
        return (
            <div className="fw_400 font_12 black45" key={"item_key_"+index}>
                <p className={"black89 font_14 mb_4"}>
                    <span className="mr_6">{item.createTime&&dayjs(item.createTime).format('YYYY-MM-DD')}</span>
                    {item.typeName}
                </p>
                <p>{item.remark}</p>
                <p>{item.createByName}</p>
            </div>
        )
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {children,record} = this.props;
        const {loading, isModalVisible,objValue, list,objErr,currState} = this.state;
        return (<>
            {children?<span onClick={()=>this.open(true)}>{children}</span>:<AuthBtn icon={"ri-flag-2-line"}
                         tips = {Lang({id:"QingGuanDengJi",default:"清关登记"})}
                         onClick={()=>this.open(true)} />}
                {isModalVisible&&<EssaModal title={Lang({id:"QingGuanJiLu",default:"清关记录"})}
                                            open={isModalVisible}
                                            onCancel={()=>this.open(false)}
                                            footer={[
                                                <Button key="back" onClick={()=>this.open(false)}>
                                                    {Lang({id:"QuXiao",default:"取消"})}
                                                </Button>,
                                                currState!="30"&&<Popconfirm
                                                   key="confirm"
                                                   title={Lang({id:"XinZengHouWuFaXiuGaiQingQueRen", default:"新增后无法修改，请确认"})}
                                                   onConfirm={()=>this.registration()}
                                                   onOpenChange={() => console.log('open change')}
                                               >
                                                   <Button
                                                       type="primary"
                                                       loading={loading}
                                                   >
                                                       {Lang({id:"XinZengJiLu",default:"新增记录"})}
                                                   </Button>
                                               </Popconfirm>
                                            ]}>
                    <Spin spinning={loading}>
                        {currState=="30"?<div className={"black89 font_14 mt_6"}>
                            {/* 集柜已清关完成 */}
                            {Lang({id:"JiGuiYiQingGuanWanCheng",default:"集柜已清关完成"})}
                        </div>:<div className={"customsClearanceWrap black89"}>
                            <p><span className={"color-red mr_2"}>*</span>{Lang({id:"QingGuanZhuangTai",default:"清关状态"})}</p>
                            {/* （ 开始清关 20:查柜 30:清关完成    原始无状态-> 清关/查柜，清关状态->查柜|完成， 查拒状态->完成 ） */}
                            <div className={"mt_4"}>
                                {isEmpty(currState)&&<span className={`mr_8 mb_8 btnCheck${objValue.type==10?" btnCheckOn":""}`} key="10" onClick={()=>this.changeInputValue("type",10)}>
                                    {Lang({id:"KaiShiQingGuan",default:"开始清关"})}
                                </span>}
                               {(isEmpty(currState)||currState=="10")&&<span className={`mr_8 mb_8 btnCheck${objValue.type==20?" btnCheckOn":""}`} key="20" onClick={()=>this.changeInputValue("type",20)}>
                                    {Lang({id:"QingGuanBeiChaGui",default:"清关被查柜"})}
                                </span>}
                               {(currState=="10"||currState=="20")&&<span className={`mb_8 btnCheck${objValue.type==30?" btnCheckOn":""}`} key="130" onClick={()=>this.changeInputValue("type",30)}>
                                    {Lang({id:"QingGuanWanCheng",default:"清关完成"})}
                                </span>}
                            </div>
                            {objErr.type&&<div className={"color-red mb_8"}>{objErr.type}</div>}
                            
                            {/* 清关完成状态下显示海关申报字段 */}
                            {objValue.type=="30"&&(
                                <div className={"mt_8"}>
                                    {/* 海关申报编码 */}
                                    <div className='flex-box align-items-center'>
                                        <div className="flex items-center mt_4 mr_10">
                                            <span className={`mr_2 ${this.state.isCustomsDeclarationRequired ? 'color-red' : ''}`}>
                                                {this.state.isCustomsDeclarationRequired ? '*' : ''}
                                            </span>
                                            <span>{Lang({id:"HaiGuanShenBaoBianMa",default:"海关申报编码"})}</span>
                                        </div>
                                        <div className="mt_2 flex-1">
                                            <Input 
                                                placeholder={Lang({id:"QingShuRuHaiGuanShenBaoBianMa",default:"请输入海关申报编码"})}
                                                onChange={(e)=>this.changeInputValue("customsDeclarationCode",e.target.value)}
                                                value={objValue.customsDeclarationCode}
                                            />
                                        </div>
                                    </div>
                                    {objErr.customsDeclarationCode&&<div className={"color-red mb_8"}>{objErr.customsDeclarationCode}</div>}
                                    
                                    {/* 海关申报日期 */}
                                    <div className='flex-box align-items-center mt_10'>
                                         <div className="flex items-center mt_4 mr_10">
                                            <span className={`mr_2 ${this.state.isCustomsDeclarationRequired ? 'color-red' : ''}`}>
                                                {this.state.isCustomsDeclarationRequired ? '*' : ''}
                                            </span>
                                            <span>{Lang({id:"HaiGuanShenBaoRiQi",default:"海关申报日期"})}</span>
                                        </div>
                                        <div className="mt_2 flex-1">
                                            <DatePicker 
                                                placeholder={Lang({id:"QingXuanZeHaiGuanShenBaoRiQi",default:"请选择海关申报日期"})}
                                                onChange={(date)=>this.changeInputValue("customsDeclarationDate",date?date.format('YYYY-MM-DD'):null)}
                                                style={{width:'100%'}} 
                                            />
                                        </div>
                                    </div>
                                    {objErr.customsDeclarationDate&&<div className={"color-red mb_8"}>{objErr.customsDeclarationDate}</div>}
                                </div>
                            )}
                            
                            {/* 备注 */}
                            <div className={"mt_8"}>
                                {Lang({id:"BeiZhu",default:"备注"})}
                            </div>
                            <div className={"mt_2 mb_16"}>
                                <TextArea rows={4} onChange={(e)=>this.changeInputValue("remark",e.target.value)}
                                          placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                          value={objValue.remark}
                                />
                            </div>
                            {/*<Button onClick={()=>this.registration()} className={"ant-btn-primary-blue"}>{Lang({id:"GengXinQingGuanXinXi",default:"更新清关信息"})}</Button>*/}
                        </div>}
                        {list.length>0?<div className={'modalLogisticsWrap'}>
                            <Timeline items={this.renderChild(list)} />
                        </div>:<Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id: 'ZanWuShuJu',default:'暂无数据'})} />}
                    </Spin>
                </EssaModal>}
            </>
        )
    }
}